// extracted by mini-css-extract-plugin
module.exports = {"donations":"styles_donations__3ooTw","donateList":"styles_donateList__3gHJX","noDonations":"styles_noDonations__2vd6N","showMore":"styles_showMore__3pwPU"};